export default __webpack_public_path__ + "static/media/facilitation-tools.66eabdd9.svg";